import React, { useState } from "react";
import { Link } from "react-router-dom";
import { imgSrc } from "../utils/images";

function prettyStatus(s) {
  const v = String(s || "").toLowerCase();
  if (!v) return "";
  if (v === "available") return "Available";
  if (v === "reserved") return "Reserved";
  if (v === "sold") return "Sold";
  if (v === "removed") return "Removed";
  return v;
}

export default function ListingCard({ item, compact = false }) {
  const [imgOk, setImgOk] = useState(true);

  if (!item || item.id == null) return null;

  const id = item.id;
  const img = item.image_path ?? item.image ?? "";
  const name = item.name ?? "Item";
  const price = Number(item.price ?? 0);
  const condition = item.item_condition ?? item.condition ?? "";
  const category =
    item.category ?? item.category_title ?? item.product_category_title ?? "";
  const status = prettyStatus(item.status ?? "");

  const desc = item.description ? String(item.description) : "";
  const shortDesc = desc.length > 90 ? desc.slice(0, 90) + "…" : desc;

  const badges = [category, condition].filter(Boolean);
  const finalSrc = imgOk ? imgSrc(img) : imgSrc("");

  return (
    <div className={`pCard listingAsCard ${compact ? "pCardCompact" : ""}`}>
      {/* Top */}
      <Link
        to={`/item/${id}`}
        className="listingAsCardLink"
        aria-label={`View ${name}`}
        title={name}
      >
        <div className="pCardMedia">
          <img
            className="pCardImg"
            src={finalSrc}
            alt={name}
            loading="lazy"
            onError={() => setImgOk(false)}
          />

          {!compact && status ? (
            <span className={`pChip pChip--${status.toLowerCase()}`}>
              {status}
            </span>
          ) : null}
        </div>

        <div className="pCardBody">
          <div className="pCardName">{name}</div>

          <div className="pCardRow">
            <div className="pCardPrice">${price.toFixed(2)}</div>
            {!compact && condition ? (
              <div className="pCardMini">{condition}</div>
            ) : null}
          </div>

          {badges.length ? (
            <div className="pCardMeta">
              {badges.map((b, i) => (
                <span key={i} className="badge">
                  {b}
                </span>
              ))}
            </div>
          ) : null}

          {!compact && shortDesc ? (
            <div className="pCardDesc">{shortDesc}</div>
          ) : null}
        </div>
      </Link>

      {/* Bottom */}
      <div className="listingAsCardActions">
        <Link className="btnSecondary" to={`/item/${id}`}>
          View
        </Link>
        <Link className="btnPrimary" to={`/edit-item/${id}`}>
          Edit
        </Link>
      </div>
    </div>
  );
}
